import * as React from "react";
import { IconProps } from "./IconProps";

export const IconFilterSort = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2.66667C2 2.29848 2.29848 2 2.66667 2H13.3333C13.7015 2 14 2.29848 14 2.66667V5.33333C14 5.51014 13.9298 5.67971 13.8047 5.80474L10 9.60948V13.3333C10 13.6392 9.7918 13.9059 9.49502 13.9801L6.82836 14.6468C6.6292 14.6966 6.4182 14.6518 6.25639 14.5255C6.09458 14.3991 6 14.2053 6 14V9.60948L2.19526 5.80474C2.07024 5.67971 2 5.51014 2 5.33333V2.66667ZM3.33333 3.33333V5.05719L7.13807 8.86193C7.2631 8.98695 7.33333 9.15652 7.33333 9.33333V13.1461L8.66667 12.8128V9.33333C8.66667 9.15652 8.7369 8.98695 8.86193 8.86193L12.6667 5.05719V3.33333H3.33333Z"
          fill={color}
        />
      </svg>
    );
  },
);
